export const PWA_UPDATE_READY_EVENT = "wishlist:pwa-update-ready";
export const PWA_OFFLINE_READY_EVENT = "wishlist:pwa-offline-ready";

const SW_UPDATE_INTERVAL_MS = 60 * 60 * 1000;

/**
 * Register the service worker and notify the app when updates are available.
 */
export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    return;
  }
  if (import.meta.env.DEV && import.meta.env.VITE_ENABLE_PWA_DEV !== "true") {
    return;
  }

  try {
    const registration = await navigator.serviceWorker.register('/sw.js');

    window.dispatchEvent(new CustomEvent(PWA_OFFLINE_READY_EVENT));
    setupRegistrationUpdateNotifications(registration);
    setupPeriodicServiceWorkerUpdate(registration);
  } catch (error) {
    console.error('Failed to register service worker.', error);
  }
}

/**
 * Ask the active waiting service worker to activate immediately.
 */
export function activateWaitingServiceWorker(waitingWorker) {
  if (!waitingWorker) {
    return;
  }
  waitingWorker.postMessage({ type: 'SKIP_WAITING' });
}

/**
 * Listen for registration updates and notify listeners.
 *
 * @param {ServiceWorkerRegistration} registration Service worker registration
 */
function setupRegistrationUpdateNotifications(registration) {
  const emitUpdateEvent = (worker) => {
    window.dispatchEvent(new CustomEvent(PWA_UPDATE_READY_EVENT, {
      detail: { waitingWorker: worker },
    }));
  };

  if (registration.waiting) {
    emitUpdateEvent(registration.waiting);
  }

  registration.addEventListener('updatefound', () => {
    const installingWorker = registration.installing;
    if (!installingWorker) {
      return;
    }

    installingWorker.addEventListener('statechange', () => {
      if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
        emitUpdateEvent(installingWorker);
      }
    });
  });
}

/**
 * Periodically ask the browser for a newer service worker script.
 *
 * @param {ServiceWorkerRegistration} registration Service worker registration
 */
function setupPeriodicServiceWorkerUpdate(registration) {
  window.setInterval(() => {
    registration.update().catch(() => {
      // Ignore update errors and try again at the next interval.
    });
  }, SW_UPDATE_INTERVAL_MS);
}
